import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
const styles = {}
class WhatWeEdit extends Component{ 
    constructor(params){
        super(params);
        this.messages = [
            'Academic Journals',
            'Academic Essays',
            'Research Papers',
            'Homework Assignments',
            'Dissertations',
            'Theses',
            'Medical Journals',
        ];
        this.maxLoops = 10;
        this.loopCount = 0;
        this.state = {
            currentMessageIndex: 0,
            currentMessage: this.messages[0],
        }
        this.freq = 2000;
        this.preventLoop = false;
        this.nextSwitch = false;
        this.prevClickTO = false;
        this.nextClickTO = false;
        this.stopTimeout = false;
    }

    componentWillUnmount(){
        this.stopTimeout = true;
    }
    componentWillMount() {
        this.stopTimeout = false;
    }
    
    currentMessage() {
        if(this.loopCount >= this.maxLoops || this.preventLoop || this.stopTimeout) return;
        this.nextSwitch = setTimeout(function(){
            var nextMessageIndex = this.state.currentMessageIndex + 1;
            if(nextMessageIndex > (this.messages.length-1)) { 
                nextMessageIndex = 0;
                this.loopCount++;
            }
            var nextMessage = this.messages[nextMessageIndex];
            if(this.stopTimeout) return;
            this.setState({currentMessageIndex: nextMessageIndex, currentMessage: nextMessage});
        }.bind(this), this.freq);
    }
    prevMessage(e) {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(this.prevClickTO);
        if(this.stopTimeout) return;
        var nextMessageIndex = this.state.currentMessageIndex - 1;
        if(nextMessageIndex < 0) {
            nextMessageIndex = this.messages.length-1;
        }
        var nextMessage = this.messages[nextMessageIndex];
        this.setState({currentMessageIndex: nextMessageIndex, currentMessage: nextMessage});
        this.preventLoop = true;
        clearTimeout(this.nextSwitch);
        this.prevClickTO = setTimeout(function(){
            this.preventLoop = false;
            this.currentMessage();
        }.bind(this), 6000);
    }
    nextMessage(e) {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(this.nextClickTO);
        if(this.stopTimeout) return;
        var nextMessageIndex = this.state.currentMessageIndex + 1;
            if(nextMessageIndex > (this.messages.length-1)) { 
                nextMessageIndex = 0;
                this.loopCount++;
            }
        var nextMessage = this.messages[nextMessageIndex];
        this.setState({currentMessageIndex: nextMessageIndex, currentMessage: nextMessage});
        this.preventLoop = true;
        clearTimeout(this.nextSwitch);
        this.nextClickTO = setTimeout(function(){
            this.preventLoop = false;
            this.currentMessage();
        }.bind(this), 6000);
    }
    render() {
        this.currentMessage();
        return(
            <div style={{width: '80%', margin: '0 auto'}}>
                <h2 className="left"  onClick={this.prevMessage.bind(this)} style={{float: 'left', lineHeight:'1.3',cursor:'pointer', fontSize: '92px'}}>&lt;</h2>
                <h2 className="right" onClick={this.nextMessage.bind(this)} style={{float: 'right', lineHeight:'1.3',cursor:'pointer', fontSize: '92px'}}>&gt;</h2>
                <center>
                    <h2 className="text-toggle" style={{color: '#ffffff', fontSize:"72px", fontFamily: 'OpenSans'}}>{this.state.currentMessage}</h2>
                </center>
            </div>
        )
    }
}
export default connect(
)(WhatWeEdit);



// WEBPACK FOOTER //
// ./src/components/pages/home/WhatWeEdit.js